import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartLine } from '@fortawesome/free-solid-svg-icons';

const CardComponent = ({ title, value, onChartClick, isActive }) => {
    return (
        <div className="card" style={{ marginBottom: '0.5rem' }}>
            <div className="card-body py-2"> {/* Reduced padding top/bottom */}
                <div className="d-flex justify-content-between align-items-center">
                    <h5 className="card-title mb-1" style={{
                        fontSize: '0.9rem',
                        lineHeight: '1.2',
                        fontWeight: 'normal'
                    }}>
                        {title}
                    </h5>
                    <FontAwesomeIcon
                        icon={faChartLine}
                        style={{
                            cursor: 'pointer',
                            color: isActive ? 'rgb(75, 192, 192)' : 'inherit',
                            marginLeft: '8px'
                        }}
                        onClick={() => onChartClick(title)}
                    />
                </div>
                <p className="card-text mb-0" style={{
                    fontSize: '1.1rem',
                    fontWeight: 'bold'
                }}>
                    $ {value}
                </p>
            </div>
        </div>
    );
};

CardComponent.propTypes = {
    title: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    onChartClick: PropTypes.func.isRequired,
    isActive: PropTypes.bool,
};

CardComponent.defaultProps = {
    isActive: false,
};

export default CardComponent;